import axios from "axios";
import { getToken } from "../../../auth/authService";

const api = axios.create({
 baseURL: process.env.REACT_APP_BASE_URL + "/admin/phrases",
 headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
 const token = getToken();
 if (token) {
 config.headers.Authorization = `Bearer ${token}`;
 } else {
 }
 return config;
});

const handle = (label, promise) =>
 promise
 .then((res) => {
 return { status: res.status, data: res.data };
 })
 .catch((err) => {
 return {
 status: err.response?.status || 500,
 message: err.response?.data?.message || "Request failed",
 };
 });

export const fetchPhrases = (params) => {
 return handle("Fetch phrases", api.get("", { params }));
};
export const fetchPhraseById = (id) => {
 return handle("Fetch phrase by id", api.get(`/${id}`));
};
export const createPhrase = (data) => {
 return handle("Create phrase", api.post("", data));
};
export const updatePhrase = (id, data) => {
 return handle("Update phrase", api.put(`/${id}`, data));
};
export const deletePhrase = (id) => {
 return handle("Delete phrase", api.delete(`/${id}`));
};
